import React from "react";
import PATH from "constants/path";
import { LIST_MENU } from "./constant";
import { icon_pMark } from "assets/img";

const FooterMenu = () => {

  const onRedirect = () => {
    window.location = 'https://privacymark.jp/';
  }
  return (
    <div className="row gx-0 py-lg-3 p-81 align-items-start">
      <div className="w-footer-menu">
        <ul className="footer-menu p-0 m-0">
          {LIST_MENU.map((item, index) => (
            <li key={index}>
              <a href={item.path}>{item.name}</a>
            </li>
          ))}
          <li>
            <a href={PATH.COMMON + PATH.AGREEMENT} target="_blank">
              会員規約
            </a>
          </li>
          <li>
            <a href={PATH.COMMON + PATH.INFORMATION} target="_blank">
              プライバシーポリシー
            </a>
          </li>
          <li>
            <a target="_blank" href={PATH.COMPANY}>
              運営会社
            </a>
          </li>
          <li>
            <a href="#"></a>
          </li>
        </ul>
      </div>
      <div className="w-footer-pMark my-2 my-lg-0">
        <div className="d-flex align-items-center border border-form-md-hidden p-3">
          <img className="footer-menu-img cursor-pointer" src={icon_pMark} alt="icon_pMark" onClick={onRedirect}/>
          <div className="ms-2 ms-md-4 fs-sm-10 footer-menu-description">
            当社は、個人情報の適切な取り扱いを行う
            事業所にのみ許可される「プライバシーマーク」の
            付与認定を受けています。
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterMenu;
